import React from 'react';
import './utils/polyfills';
import { installAnalyticsFetchPriority } from './utils/analyticsFetchPriority';

import './styles/styles-header.scss';
import './styles/dftams-ui-styles.scss';
import App from './App';
import { createRoot } from 'react-dom/client';
import { LocalStorageUtil } from './utils/LocalStorageUtil';
import { preloadLoginBackground } from './AppRouter/PublicRoutes/preloadLoginBackground';

installAnalyticsFetchPriority();
LocalStorageUtil.cleanupDeprecatedKeys();
preloadLoginBackground(window.location.pathname);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
